module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-2-zoom.eefa12e3.png";